module.exports = __webpack_public_path__ + "img/26.ea9ec026.png";